import { useParams } from "react-router-dom";
import { SearchTermsContentV2 } from "@/components/search-terms/SearchTermsContentV2";

export default function ProductSearchTermsPage() {
  const { productId } = useParams<{ productId: string }>();

  return (
    <div className="p-6 [&_table]:border-0 [&_.v2-table-section]:rounded-none [&_.v2-table-section]:border-x-0 [&_.v2-table-section]:border-b-0">
      <SearchTermsContentV2 productId={productId} />
    </div>
  );
}
